let menuEl = null;
let removeListeners = null;

function ensureMenu() {
    if (menuEl) return menuEl;

    const style = document.createElement('style');
    style.textContent = `
        .custom-ctx-menu {
            position: absolute;
            z-index: 9999;
            background: var(--elementBackground);
            border: 1px solid var(--borderColor);
            border-radius: 8px;
            padding: 4px;
            min-width: 170px;
            box-shadow: 0 4px 16px rgba(0,0,0,0.35);
            font-family: inherit;
            font-size: 13px;
            color: var(--text);
        }
        .custom-ctx-item {
            display: flex;
            align-items: center;
            gap: 9px;
            padding: 8px 12px;
            border-radius: 5px;
            cursor: pointer;
            color: var(--text);
            transition: background 0.12s;
            white-space: nowrap;
        }
        .custom-ctx-item:hover {
            background: var(--sidebarIconsHover);
        }
        .custom-ctx-item.danger:hover {
            background: color-mix(in srgb, #e05252 15%, transparent);
            color: #e05252;
        }
        .custom-ctx-separator {
            height: 1px;
            background: var(--borderColor);
            margin: 4px 8px;
        }
    `;
    document.head.appendChild(style);

    menuEl = document.createElement('div');
    menuEl.className = 'custom-ctx-menu';
    menuEl.style.display = 'none';
    document.body.appendChild(menuEl);
    return menuEl;
}

function closeMenu() {
    if (menuEl) menuEl.style.display = 'none';
    removeListeners?.();
    removeListeners = null;
}

export function showContextMenu(event, items) {
    event.preventDefault();
    event.stopPropagation();
    closeMenu();

    const menu = ensureMenu();
    menu.innerHTML = '';

    for (const item of items) {
        if (item.separator) {
            const sep = document.createElement('div');
            sep.className = 'custom-ctx-separator';
            menu.appendChild(sep);
            continue;
        }
        const element = document.createElement('div');
        element.className = 'custom-ctx-item' + (item.cssClass ? ` ${item.cssClass}` : '');
        element.innerHTML = item.label;
        element.addEventListener('click', () => { closeMenu(); item.action?.(); });
        menu.appendChild(element);
    }

    menu.style.visibility = 'hidden';
    menu.style.display = 'block';

    const posX = event.pageX;
    const posY = event.pageY;
    const menuWidth = menu.offsetWidth;
    const menuHeight = menu.offsetHeight;
    menu.style.left = (posX + menuWidth > window.innerWidth  ? posX - menuWidth : posX) + 'px';
    menu.style.top  = (posY + menuHeight > window.innerHeight + window.scrollY ? posY - menuHeight : posY) + 'px';
    menu.style.visibility = '';

    const onMouseDown = (event) => { if (!menu.contains(event.target)) closeMenu(); };
    const onKeyDown   = (event) => { if (event.key === 'Escape') closeMenu(); };

    setTimeout(() => {
        document.addEventListener('mousedown', onMouseDown);
        document.addEventListener('keydown',   onKeyDown);
    }, 0);

    removeListeners = () => {
        document.removeEventListener('mousedown', onMouseDown);
        document.removeEventListener('keydown',   onKeyDown);
    };
}